import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { toModifier } from 'legacy/libs/utils'
import createReactClass from 'create-react-class'

import s from './popup.module.scss'

export default createReactClass({
  displayName: 'Popup',

  propTypes: {
    modifier: PropTypes.string,
    className: PropTypes.string,
    padding: PropTypes.string,
    children: PropTypes.any, // eslint-disable-line
  },

  render() {
    const { modifier, className, padding, children } = this.props

    return (
      <div
        className={className || classNames(s.popup, s[toModifier(modifier)])}
      >
        <div className={s.shadow} />
        <div className={s.content} style={padding ? { padding } : {}}>
          {children}
        </div>
      </div>
    )
  },
})
